import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $filter, $timeout, LocaleService, submissionViewModel, StateUtils) {

    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();
    var chosenQuoteId = StateUtils.activeDataForState(true).chosenQuote;

    ctrl.init = function () {
        console.log('WCOwnersAndOfficersCtrl.init submission:');
        console.log(submissionVM.value);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$timeout', 'LocaleService', 'submissionViewModel', 'StateUtils'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/controllers/WCOwnersAndOfficersCtrl.js
// module id = 1298
// module chunks = 0